import { SelectMenu } from '@scale/scaleui';
import { ChatBulkAuditObjectType } from '@scale/genai-compass-shared/cards/chat_bulk_audit';

export interface ObjectTypePickerProps {
  selectedObjectType: ChatBulkAuditObjectType | undefined;
  setSelectedObjectType: (selectedObjectType: ChatBulkAuditObjectType) => void;
}

export default function ObjectTypePicker({
  selectedObjectType,
  setSelectedObjectType,
}: ObjectTypePickerProps) {
  const DISPLAY_TEXT_MAP: Record<string, string> = {
    [ChatBulkAuditObjectType.WORKER]: 'Worker',
    [ChatBulkAuditObjectType.TASK]: 'Task / Task Attempt',
  };

  return (
    <SelectMenu
      className="w-96"
      menuDirection="bottom"
      options={Object.values(ChatBulkAuditObjectType).map(type => ({
        id: type,
        name: DISPLAY_TEXT_MAP[type] || type,
      }))}
      selectedOptionId={selectedObjectType ?? ''}
      setSelected={(v: string) => setSelectedObjectType(v as ChatBulkAuditObjectType)}
      disabled={false}
    />
  );
}
